<template>
  <v-dialog max-width="500px" fullscreen v-model="active" persistent>
    <v-card>
      <v-card-title :style="{ backgroundImage: gradientString() }">
        {{ editing ? "Edit an Existing Palette" : "Create a New Palette" }}
      </v-card-title>
      <v-card-actions>
        <v-container>
          <v-text-field label="Name" v-model="name" :disabled="editing">
          </v-text-field>
          <v-row v-for="(color, index) in colors" :key="index" justify="center">
            <v-color-picker
              canvas-height="100"
              v-model="colors[index]"
              hide-inputs
            >
            </v-color-picker>
            <v-btn icon color="error" @click="colors.splice(index, 1)">
              <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
          </v-row>
          <v-row class="pt-10">
            <v-btn
              color="secondary"
              variant="text"
              @click="colors.push('#FF00FF')"
              :disabled="colors.length > 7"
              >Add Color
            </v-btn>
          </v-row>
          <v-row class="pt-10">
            <v-btn variant="outlined" color="accent" @click="$emit('cancel')"
              >Cancel</v-btn
            >
            <v-btn v-if="editing" color="error" @click="$emit('delete', name)"
              >Delete</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="$emit('submit', name, colors)"
              :disabled="
                colors.length < 2 || colors.length > 8 || name.length == 0
              "
            >
              {{ editing ? "Modify Palette" : "Create Palette" }}
            </v-btn>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    editing: Boolean,
    propColors: Object,
    propName: String,
  },
  created() {
    if (this.editing) {
      this.name = this.propName;
      this.colors = [...this.propColors];
    }
  },
  methods: {
    gradientString() {
      return "linear-gradient(30deg," + this.colors.toString() + ")";
      //   return "linear-gradient(30deg, blue, red)";
    },
  },
  data: () => ({
    colors: ["#000000", "#FFFFFF"],
    name: "",
    active: true,
  }),
};
</script>